'use strict';

module.exports.POSTAL_CODE_PATTERNS_BY_COUNTRY_CODE = {
  AD: '^(AD\\d{3})$',
  AF: '^((([1-3][0-9])|(4[0-3]))\\d{4})$',
  AI: '^AI-2640$',
  AL: '^\\d{4}$',
  AM: '^(\\d{4})$',
  AR: '^([A-Z]\\d{4}[A-Z]{3})$',
  AS: '^(96799(-\\d{4})?)$',
  AT: '^\\d{4}$',
  AU: '^\\d{4}$',
  AZ: '^(AZ\\d{4})$',
  BA: '^\\d{5}$',
  BB: '^BB\\d{5}$',
  BD: '^\\d{4}$',
  BE: '^\\d{4}$',
  BG: '^\\d{4}$',
  BH: '^(\\d{3,4})$',
  BM: '^([A-Z]{2} [A-Z0-9]{2})$',
  BN: '^[A-Z]{2}\\d{4}$',
  BR: '^\\d{5}-\\d{3}$',
  BT: '^\\d{5}$',
  BY: '^\\d{6}$',
  CA: '^([A-CEGHJ-NPR-TV-Z]\\d[A-CEGHJ-NPR-TV-Z] \\d[A-CEGHJ-NPR-TV-Z]\\d)$',
  CC: '^6799$',
  CH: '^([1-9]\\d{3})$',
  CL: '^\\d{7}$',
  CN: '^\\d{6}$',
  CO: '^\\d{6}$',
  CR: '^\\d{5}$',
  CU: '^(((CP )?\\d{5})|((CP)?\\d{5}))$',
  CV: '^\\d{4}$',
  CX: '^6798$',
  CY: '^(([1-9]\\d{3})|(99\\d{3}))$',
  CZ: '^([1-7][0-9]{2} [0-9]{2}|[1-7][0-9]{4})$',
  DE: '^\\d{5}$',
  DK: '^(DK-)?\\d{4}$',
  DO: '^\\d{5}$',
  DZ: '^\\d{5}$',
  EC: '^\\d{6}$',
  EE: '^\\d{5}$',
  EG: '(^\\d{5}|\\d{7})$',
  ES: '^\\d{5}$',
  ET: '^\\d{4}$',
  FI: '^(FI-)?\\d{5}$',
  FK: '^FIQQ 1ZZ$',
  FM: '^(9694[1-4]{1}(-\\d{4})?)$',
  FO: '^\\d{3}$',
  FR: '^\\d{3}[ ]?\\d{2}$',
  GB:
    '^(GIR[ ]?0AA|((AB|AL|B|BA|BB|BD|BH|BL|BN|BR|BS|BT|CA|CB|CF|CH|CM|CO|CR|CT|CV|CW|DA|DD|DE|DG|DH|DL|DN|DT|DY|E|EC|EH|EN|EX|FK|FY|G|GL|GY|GU|HA|HD|HG|HP|HR|HS|HU|HX|IG|IM|IP|IV|JE|KA|KT|KW|KY|L|LA|LD|LE|LL|LN|LS|LU|M|ME|MK|ML|N|NE|NG|NN|NP|NR|NW|OL|OX|PA|PE|PH|PL|PO|PR|RG|RH|RM|S|SA|SE|SG|SK|SL|SM|SN|SO|SP|SR|SS|ST|SW|SY|TA|TD|TF|TN|TQ|TR|TS|TW|UB|W|WA|WC|WD|WF|WN|WR|WS|WV|YO|ZE)(\\d[\\dA-Z]?[ ]?\\d[ABD-HJLN-UW-Z]{2}))|BFPO[ ]?\\d{1,4})$',
  GE: '^\\d{4}$',
  GG: '^GY\\d[\\dA-Z]?[ ]?\\d[ABD-HJLN-UW-Z]{2}$',
  GI: '^GX11 1AA$',
  GL: '^39\\d{2}$',
  GN: '^\\d{3}$',
  GR: '^\\d{3}\\s{0,1}\\d{2}$',
  GS: '^SIQQ 1ZZ$',
  GT: '^\\d{5}$',
  GU: '^(((969)((1[023567])|(2[1389])|(3[12])))(-\\d{4})?)$',
  GW: '^\\d{4}$',
  HK: '^(999077)?$',
  HM: '^7151$',
  HN: '^\\d{5}$',
  HR: '^([1-5]\\d{4})$',
  HT: '^(HT\\d{4})$',
  HU: '^([1-9]\\d{3})$',
  ID: '^([1-9]\\d{4})$',
  IL: '^\\d{7}$',
  IM: '^((IM)([0-9][0-9A-HJKPS-UW]?|[A-HK-Y][0-9][0-9ABEHMNPRV-Y]?) [0-9][ABD-HJLNP-UW-Z]{2})$',
  IN: '^([1-9]\\d{5})$',
  IQ: '^\\d{5}$',
  IR: '^\\d{10}$',
  IS: '^([1-9]\\d{2})$',
  IT: '^\\d{5}$',
  JE: '^(JE[0-9]{1}[\\s]([\\d][A-Z]{2}))$',
  JM: '^((\\d{1,2})?)$',
  JO: '^\\d{5}$',
  JP: '^\\d{3}-\\d{4}$',
  KE: '^\\d{5}$',
  KG: '^\\d{6}$',
  KH: '^\\d{5,6}$',
  KR: '^\\d{5}$',
  KW: '^\\d{5}$',
  KY: '^KY[123]-\\d{4}$',
  KZ: '^(([A-Z]\\d{2}[A-Z]\\d[A-Z]\\d)|(\\d{6}))$',
  LA: '^\\d{5}$',
  LB: '^(\\d{4}( \\d{4})?)$',
  LI: '^\\d{4}$',
  LK: '^\\d{5}$',
  LR: '^\\d{4}$',
  LS: '^\\d{3}$',
  LT: '^(((LT)[\\-])?(\\d{5}))$',
  LU: '^(((L)[\\-])?(\\d{4}))$',
  LV: '^(LV\\-\\d{4})$',
  MA: '[1-9]\\d{4}',
  MD: '^(MD\\-\\d{4})$',
  ME: '^\\d{5}$',
  MG: '^\\d{3}$',
  MH: '^(((969)[6-7][0-9])(-\\d{4})?)$',
  MK: '^\\d{4}$',
  MM: '^((\\d{5})|(\\d{7}))$',
  MN: '^\\d{5}$',
  MP: '^(9695[0-2]{1}(-\\d{4})?)$',
  MS: '^MSR\\d{4}$',
  MT: '^([A-Z]{3} [0-9]{4}|[A-Z]{2}[0-9]{2}|[A-Z]{2} [0-9]{2}|[A-Z]{3}[0-9]{4}|[A-Z]{3})$',
  MU: '^(([0-9A-R]\\d{4}))$',
  MV: '^\\d{5}$',
  MX: '^\\d{5}$',
  MY: '^\\d{5}$',
  MZ: '^\\d{4}$',
  NC: '^988\\d{2}$',
  NE: '^\\d{4}$',
  NF: '^2899$',
  NG: '^[1-9]\\d{5}$',
  NI: '^\\d{5}$',
  NL: '^(([1-9]\\d{3} [A-Z]{2})|([1-9]\\d{3}[A-Z]{2}))$',
  NO: '^\\d{4}$',
  NP: '^\\d{5}$',
  NZ: '^\\d{4}$',
  OM: '^\\d{3}$',
  PA: '^(\\d{4})$',
  PE: '^\\d{5}$',
  PF: '^987\\d{2}$',
  PG: '^\\d{3}$',
  PH: '^\\d{4}$',
  PK: '^[1-9]\\d{4}$',
  PL: '^\\d{2}-\\d{3}$',
  PN: '^(PCR9 1ZZ)$',
  PT: '^([1-9]\\d{3}((-)?\\d{3}))$',
  PW: '^(96939|96940)$',
  PY: '^\\d{6}$',
  RO: '^\\d{6}$',
  RS: '^\\d{5,6}$',
  RU: '^\\d{6}$',
  SA: '^([1-8]\\d{4}([\\-]\\d{4})?)$',
  SD: '^\\d{5}$',
  SE: '^([1-9]\\d{2} \\d{2})$',
  SG: '^\\d{6}$',
  SH: '^((ASCN 1ZZ|TDCU 1ZZ|STHL 1ZZ))$',
  SI: '^([1-9]\\d{3})$',
  SK: '^((\\d{3} \\d{2})|\\d{5})$',
  SM: '^4789\\d$',
  SN: '^([1-8]\\d{4})$',
  SV: '^\\d{4}$',
  SZ: '^[HLMS]\\d{3}$',
  TC: '^TKCA 1ZZ$',
  TH: '^\\d{5}$',
  TJ: '^7\\d{5}$',
  TM: '^7\\d{5}$',
  TN: '^\\d{4}$',
  TR: '^\\d{5}$',
  TT: '^\\d{6}$',
  TW: '(\\d{3}\\-\\d{3})|(\\d{3}[-]\\d{2})|(\\d{6})|(\\d{3})',
  UA: '^\\d{5}$',
  US: '^\\d{5}(-\\d{4})?$',
  UY: '^([1-9]\\d{4})$',
  UZ: '^\\d{6}$',
  VA: '^(00120)$',
  VC: '^VC\\d{4}$',
  VE: '^([1-8]\\d{3})$',
  VG: '^((VG11)[1-6][0])$',
  VI: '^(008\\d{2}(-\\d{4})?)$',
  VN: '^(\\d{5})$',
  WF: '^986\\d{2}$',
  WS: '^(WS[1-2]\\d{3})$',
  ZA: '^\\d{4}$',
  ZM: '^\\d{5}$'
};
